<template>
  <div class="HashPower HashPowerPage">
    <!-- <MyHeader title="协 鑫 智 算（苏 州）中 心" /> -->
    <MyHeader :imgUrl="require('@/assets/images/exposition/header/header5.png')" title="协 鑫 智 算 算 力 调 度 平 台" />
    <div class="page-left flex justify-content-between" :style="{'width': type == 1 ? '1762px' : '1562px'}">
      <div class="page-1">
        <Part1 class=""/>
        <Part2 class="mt_30"/>
        <Part3 class="mt_30"/>
      </div>
      <div class="page-2">
        <Part4 class=""/>
        <Part5 class="mt_30"/>
        <Part6 class="mt_50"/>
      </div>
    </div>
    <div class="page-center">
      <!-- <TopTitle class="mt-150"/> -->
      <MyNumber class="disNumber"/>
      <MyCenter />
    </div>
    <div class="page-right">
      <Part9 />
      <title1 class="title-scale" type="1" title="协鑫智算（苏州）中心" style="margin-top: 30px" />
      <!-- <video style="width: 894px; margin-top: 20px;" src="https://sass.gclme.com/web-video/zhisuan.mp4"></video> -->

      <el-carousel
        class="el-carousel"
        indicator-position="none"
        arrow="never"
        :interval="50000"
        ref="myCarousel">
        <el-carousel-item
          v-for="(item, index) in monArr"
          :key="index"
          :name="index + '1'">
					<video
            muted
						class="videoa video-js"
						:playUrl="item"
						:ref="`my-player${index}`"
            autoplay>
          </video>
        </el-carousel-item>
      </el-carousel>
      <title1 class="title-scale" type="1" title="协鑫智算（上海）中心" style="margin-top: 50px" />
      <el-carousel
					class="el-carousel"
					indicator-position="none"
					arrow="never"
          :interval="50000"
					ref="myCarousel">
					<el-carousel-item name="0">
            <div style="position: relative;">
              <span style="position: absolute; top: 35px; color: #fff;font-size: 28px;">{{ nowDate }} {{ nowWeek }} {{ nowTime }}</span>
              <video style="width: 894px; margin-top: 20px;" src="https://sass.gclme.com/web-video/zs-jiankong-sh1.mp4"></video>
            </div>
					</el-carousel-item>
					<el-carousel-item name="1">
            <div style="position: relative;">
              <span style="position: absolute; top: 35px; color: #fff;font-size: 28px;">{{ nowDate }} {{ nowWeek }} {{ nowTime }}</span>
              <video style="width: 894px; margin-top: 20px;" src="https://sass.gclme.com/web-video/zs-jiankong-sh2.mp4"></video>
            </div>
					</el-carousel-item>
				</el-carousel>
      <!-- <Part7 class="mt_30"/> -->
      <!-- <Part8 /> -->
      <!-- <video rtsp="RTSP://223.112.236.134:5054/STREAMING/CHANNELS/2601"></video> -->
    </div>
  </div>
</template>

<script>
import MyHeader from "./../../components/myHeader.vue";
import MyCenter from "./center.vue";
import Part1 from "./../../components/HashPowerCom/part-1.vue";
import Part2 from './../../components/HashPowerCom/part-2.vue'
import Part3 from "./../../components/HashPowerCom/part-3.vue";
import Part4 from "./../../components/HashPowerCom/part-5.vue";
import Part5 from "./../../components/HashPowerCom/part-4.vue";
import Part6 from "./../../components/HashPowerCom/part-6.vue";
import Part7 from './../../components/HashPowerCom/part-7.vue'
import Part8 from './../../components/HashPowerCom/part-8.vue'
import Part9 from './../../components/HashPowerCom/part-9.vue'
import TopTitle from "./../../components/TopTitle.vue";
import title1 from '@/views/exposition/components/title2'
import MyNumber from "../../components/myNumbers.vue";

import { dataInterface } from '@/api/dataInterfaceApi'

export default {
  props: {
    type: String,
    default: 0
  },
  components: {
    MyHeader,
    MyCenter,
    Part1,
    Part2,
    Part3,
    Part4,
    Part5,
    Part6,
    Part7,
    Part8,
    Part9,
    TopTitle,
    title1,
    MyNumber,
  },
  data() {
    return {
      monArr: [],
      countdownInterval: null,
      nowTime: '',
      nowWeek: '',
      nowDate: '',
    }
  },
  mounted() {
    let data = {
      "gclYingShiPlayList" : [
          {
              "deviceSerial":"AA3704183",
              "channelNo": 3,
              "protocol": 2
          }, 
          {
              "deviceSerial":"AA3704183",
              "channelNo": 14,
              "protocol": 2
          }
      ]
    }
    dataInterface.getYingShiAddress(data)
    .then((res) => {
      console.log('23234234', res)
      this.monArr = res || []
      this.setVideo()
    })

		this.currentTime()
  },
  methods: {

		currentTime() {
			if(this.countdownInterval) clearInterval(this.countdownInterval);
			this.countdownInterval = setInterval(this.getDate, 60);
		},
		getDate: function() {
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let week = new Date().getDay();
			let hh = new Date().getHours();
			let mf =
				new Date().getMinutes() < 10 ?
				"0" + new Date().getMinutes() :
				new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ?
				"0" + new Date().getSeconds() :
				new Date().getSeconds()
			if (week == 1) {
				this.nowWeek = "星期一";
			} else if (week == 2) {
				this.nowWeek = "星期二";
			} else if (week == 3) {
				this.nowWeek = "星期三";
			} else if (week == 4) {
				this.nowWeek = "星期四";
			} else if (week == 5) {
				this.nowWeek = "星期五";
			} else if (week == 6) {
				this.nowWeek = "星期六";
			} else {
				this.nowWeek = "星期日";
			}
			_this.nowTime = hh + ':' + mf + ':' + ss;
			_this.nowDate = yy + '年' + mm + '月' + dd + '日';
			// _this.nowDate = yy + "-" + mm + "-" + dd + "-";
		},
    setVideo() {
      this.videoObj = {}
      this.$nextTick(() => {
        this.monArr.forEach((item, index) => {
          const playerDom = this.$refs[`my-player${index}`][0]
          Object.assign(this.videoObj, {
            [`video${index}`]: videojs(
              playerDom,
              {
                // autoplay: true, // 设置自动播放
                controls: true, // 显示播放的控件
                preload: 'metadata',
                aspectRatio: '16:9',
                fluid: true,
                sources: [
                  // 注意，如果是以option方式设置的src,是不能实现 换台的 (即使监听了nowPlayVideoUrl也没实现)
                  {
                    src: playerDom.attributes.playUrl.nodeValue,
                    type: 'application/x-mpegURL', // 告诉videojs,这是一个hls流
                  },
                ],
              },
            ),
          })
        })
      })
    }
  },
	// 销毁定时器
	beforeDestroy: function() {
		// 在Vue实例销毁前，清除时间定时器
		clearInterval(this.countdownInterval)
	},
};
</script>

<style lang="scss" scoped>
@import "./../../components/comm.scss";

.disNumber {
  position: absolute;
  top: 525px;
  left: 300px;
}
.HashPowerPage {
  .el-carousel {
    height: 500px;
  }
}
</style>